import * as React from 'react'
import {
  ThemeProvider as Root,
  createGlobalStyle,
} from './themedStyledComponents'
import { theme } from './theme'
import { reset } from './reset'
import { reboot } from './reboot'
import { fontFaces } from './css/fonts'

const BaseStyles = createGlobalStyle`
  ${reset};
  ${reboot};
  ${fontFaces};
`

export const ThemeProvider: React.SFC = ({ children }) => {
  return (
    <>
      <BaseStyles />
      <Root theme={theme}>
        <>{children}</>
      </Root>
    </>
  )
}
